import { render } from "./VideoOPD.vue?vue&type=template&id=c2681512"
import script from "./VideoOPD.vue?vue&type=script&lang=js"
export * from "./VideoOPD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__